import { useTrack as useTrackV2 } from '@sortlist-frontend/tracking';
import { useTranslation } from '@sortlist-frontend/translation';
import { ForwardedRef, Fragment, useEffect } from 'react';

import { usePublicAppContext } from '_core/context/public-app-context';
import { PublicApiRepo, useGetAgencies, useGetPage } from '_core/repos/public-api.repo';
import { useTrack } from '_core/repos/track.repo';
import { customConfig } from '_features/custom/custom.config';
import { AgenciesPanel } from '_features/longtail/sections';

import { PageSeoTag } from '../../components/SEO';

type Props = {
  scrollableCtn?: ForwardedRef<HTMLDivElement>;
  disableCache?: boolean;
  children?: never;
};

export const DirectoryEmbedPage: React.FC<Props> = () => {
  const { data: page } = useGetPage(PublicApiRepo.publicApiUrl);
  const { mutateAsync: internalTrack } = useTrack();
  const { data: organicAgencies } = useGetAgencies(PublicApiRepo.publicApiUrl, 'organic');
  const { data: paidAgencies } = useGetAgencies(PublicApiRepo.publicApiUrl, 'paid');
  const { canonical, domainInfo, locale } = usePublicAppContext();
  const { t } = useTranslation(customConfig.i18nNamespaces);
  const { track } = useTrackV2({ app: 'public', locale });

  const isHubTypePage = page?.data.attributes.frontend_type === 'max';

  useEffect(() => {
    internalTrack({ name: 'longtailLoaded', url: location.href }).catch(() => {});
    track({ slug: 'longtailView', data: { page_id: page?.data?.id, pageId: page?.data?.id } });
  }, []);

  const hasAgencies = organicAgencies?.data != null && organicAgencies?.data.length > 0;

  return page != null ? (
    <Fragment>
      <PageSeoTag
        title={page.data.attributes.metadata.title_tag}
        description={page.data.attributes.metadata.metadescription}
        nextSeoProps={{
          nofollow: page.data.attributes.indexable !== true,
          noindex: page.data.attributes.indexable !== true,
        }}
        canonical={canonical}
      />
      <Fragment>
        {!isHubTypePage && hasAgencies ? (
          <div className="relative pb-16 max-sm:pb-12">
            <AgenciesPanel
              organicAgencies={organicAgencies}
              paidAgencies={paidAgencies}
              page={page}
              t={t}
              navigationData={{ locale, origin: domainInfo?.getOriginUrl() ?? '' }}
            />
          </div>
        ) : null}
      </Fragment>
    </Fragment>
  ) : null;
};
